// extracted by mini-css-extract-plugin
export default {"recos":"n5-z","productCardOverride":"o5-z","rowHasBadge":"p5-z"};